import React from 'react';
import AskSLAMAI from '../../components/chat/AskSLAMAI';

const SOCCER_PROMPTS = [
  { id: 1, text: 'Analyze pressing patterns and defensive shape', icon: '⚽' },
  { id: 2, text: 'Compare xG and shot quality for this match', icon: '📊' },
  { id: 3, text: 'Scout report on opposing midfielder', icon: '🔍' },
  { id: 4, text: 'Set piece design for corner kicks', icon: '🎯' },
  { id: 5, text: 'Player heat map and positional analysis', icon: '🗺️' },
  { id: 6, text: 'Transition speed and counter-attack patterns', icon: '⚡' },
];

export default function SoccerAskAI() {
  return (
    <AskSLAMAI
      sport="soccer"
      prompts={SOCCER_PROMPTS}
      endpoint="/api/chat/statcast"
      accentColor="emerald"
    />
  );
}
